import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import {
  CustomSelect,
  FloatInput,
  TextInput,
} from "components/Input/Index.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { site, meter as metertext} from "variables/patrimoine.js";
import {datedistributionData} from "variables/lists/meters";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getSite, getAccountMeters } from "services/ConfigServices";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      backgroundColor: '#fff',
      //width: "30ch",
    },
  },
  formControl: {
    margin: '8px',
    minWidth: 120,
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function AddMeterDialog(props) {
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [prevData, setPrevData] = useState();
  const [meternumber, setMeternumber] = useState("");
  const [meter, setMeter] = useState({});
  const [divisionunit, setDivisionunit] = useState("");
  const [divisionvalue, setDivisionvalue] = useState("");
  const [datedistribution, setDatedistribution] = useState("");
  const [functioncode, setFunctioncode] = useState("");
  const [creditline, setCreditline] = useState("");

  const [accountid, setAccountid] = useState(0);
  const [accountMeters, setAccountMeters] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, energy, parameters, deleteCounter } = props;

  const handleMeternumberChange = (newValue) => {
    setMeter(newValue);
    setMeternumber(newValue.id);
  };
  const handleDivisionunitChange = (event) => { setDivisionunit(event.target.value); };
  const handleDivisionvalueChange = (event) => { setDivisionvalue(event.target.value); };
  const handleDatedistributionChange = (event) => { setDatedistribution(event.target.value); };

  const handleFunctioncodeChange = (event) => { setFunctioncode(event.target.value); };
  const handleCreditlineChange = (event) => { setCreditline(event.target.value); };

  const selectedMeter = () => {
    let selected = {};
    if (meter !== undefined) {
      selected = meter;
    }
    return selected;
  };

  useEffect(() => {
    if (
      meternumber.length > 0 &&
      divisionunit.length > 0 &&
      divisionvalue.length > 0 &&
      datedistribution.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [meternumber, divisionunit, divisionvalue, datedistribution]);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "energy." + energy + "." + parameters),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail.energy);
        setAccountid(res.data.detail?.account);
      });
  }, [deleteCounter]);

  useEffect(() => {
    if (accountid > 0) {
      axios
        .get(
          getAccountMeters(accountid, energy),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let tmpMetersData = res.data.meters?.map((data) => {
            return (
              { name: data.meternumber, id: data.meternumber }
            );
          });
          setAccountMeters(tmpMetersData || []);
        });
    }
  }, [accountid]);

  const handleSubmit = async (event) => {
    let meters = prevData?.[energy]?.meters || [];

    const newMeters = {
      meternumber,
      divisionunit,
      divisionvalue,
      datedistribution,
      functioncode,
      creditline,
      'uuid': uuid(),
    };

    meters.push(newMeters);

    axios
      .put(
        getSite(chartIdGroup, "energy." + energy + "." + parameters),
        meters,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => { });
  };

  const divisionUnitData = [
    { name: "%", id: "percent" },
    { name: "m²", id: "sqrmtr" },
    { name: "autre", id: "other" },
  ];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <AutocompleteInputMeters
                inputMargin={"1rem 0rem 0rem"}
                specialWidth={"97%"}
                inputTitle={site.energy[energy][parameters].meternumber}
                selected={selectedMeter()}
                list={accountMeters}
                handleChange={(_, newValue) =>
                  handleMeternumberChange(newValue)
                }
              />
              {/* <CustomSelect
                inputTitle={
                  site.energy[energy][parameters].meternumber
                }
                selectValue={meternumber}
                handleSelectValueChange={handleMeternumberChange}
                data={accountMeters}
              /> */}
            </div>
            <div>
              <CustomSelect
                inputTitle={site.energy[energy][parameters].divisionunit}
                selectValue={divisionunit}
                handleSelectValueChange={handleDivisionunitChange}
                data={divisionUnitData}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={site.energy[energy][parameters].divisionvalue}
                floatInput={divisionvalue}
                handleFloatInputChange={handleDivisionvalueChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={metertext.datedistribution}
                selectValue={datedistribution}
                handleSelectValueChange={handleDatedistributionChange}
                data={datedistributionData}
              />
            </div>
            <div>
              <TextInput
                inputTitle={metertext.functioncode}
                textInput={functioncode}
                handleTextInputChange={handleFunctioncodeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={metertext.creditline}
                textInput={creditline}
                handleTextInputChange={handleCreditlineChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <CreateButton buttonDisabled={buttonDisabled} handleSubmit={handleSubmit} />
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}></GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddMeterDialog;
